/**
 * @desc 财务画像-基础信息-关键财务指标趋势对比
 */
import style from './indexContrastLine.scss';
import React from 'react';
import NoData from '../../../common/noData/NoData';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import { Spin } from 'antd';
import { isNotEmpty } from '../../../../utils/util';
import { commonLineOptin } from '../../common/commons';

export default function IndexContrastLine({ name, data, takingData, year, trendLoading }) {

    let grid = {
            top: 25,
            right: '8%',
            containLabel: true
        }, color = ['#3370C8', '#F99248'],
        param = {
            lineData: [{ name: name, data: data }, { name: takingData.name, data: takingData.data }],
            category: year, color: color, grid: grid,
            same: false, tip: false, title: false
        },
        opt = commonLineOptin(param);

    return (
        <div>
            {
                trendLoading ? <Spin tip="数据加载中..." /> :
                    isNotEmpty(data) ?
                        <div className={style.indexContrast}>
                            <BBDLineBar option={opt} />
                        </div> : <NoData />
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/common/IndexContrastLine.jsx